import { render, staticRenderFns } from "./Four.vue?vue&type=template&id=472a82ca"
import script from "./Four.vue?vue&type=script&lang=js"
export * from "./Four.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports